import { NgModule } from '@angular/core';

import { ButtonModule } from '../common/button/button.module';
import { DividerModule } from '../common/divider/divider.module';
import { ThreadExpanderComponent } from './thread-expander.component';

@NgModule({
  imports: [DividerModule, ButtonModule],
  declarations: [ThreadExpanderComponent],
  exports: [ThreadExpanderComponent],
})
export class ThreadExpanderModule {}

export { ThreadExpanderComponent } from './thread-expander.component';
